// NATIVE
import React from 'react';

// INSTALLED

// CUSTOM
import { useSelector } from 'react-redux';
import { Grid, TextField } from '@mui/material';

/**
 * DetalleArea component displays the details of an area.
 *
 * @param {any} props - The properties passed to the component.
 *
 * @returns {JSX.Element} A React component that renders the details of an area.
 *
 * @remarks
 * This component uses the `useSelector` hook to access the `area` from the Redux store.
 * It also uses the `useEffect` hook to update the local state `dataArea` whenever the `area` changes.
 *
 * @example
 * ```tsx
 * <DetalleArea />
 * ```
 */
export const DetalleArea = (props: any) => {
  // USE SELECTOR
  const { area }: any = useSelector((state: any) => state.areas);
  const [dataArea, setDataArea] = React.useState<any>(null);

  // USE EFFECT
  React.useEffect(() => {
    setDataArea(area);
  }, [area]);

  return (
    <div>
      {dataArea && (
        <>
          <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
              <TextField
                fullWidth
                name={dataArea.name}
                label={'Area'}
                defaultValue={dataArea.name}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
              <TextField
                fullWidth
                multiline
                rows={5}
                name={dataArea.description}
                label={'Descripcion'}
                defaultValue={dataArea.description}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          <Grid>
            <Grid size={12} sx={{ padding: 2 }}>
              <TextField
                fullWidth
                name={dataArea.branch.name}
                label={'Sucursal'}
                defaultValue={dataArea.branch.name}
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
};
